import Vue from 'vue'

import ApiService from '@/common/api.service'

import AuthenticationService from '@/common/authentication.service';

import AuthenticationTemplateService from '@/common/authenticationtemplate.service';

import {
	GET_AUTHENTICATION_ZONE_BY_LOCATION,
	GET_TEMPLATE_METHOD_VARIABLES,
	APPLY_TEMPLATE_PATH
} from '@/store/actions.type'

import {
	SET_AUTHENTICATION_ZONE,
	SET_TEMPLATE_PATH,
	SET_TEMPLATE_VARIABLES
} from '@/store/mutations.type'

const state = {
	authenticationZone: {},
	templateVariables: []
}

const actions = {
	async [GET_AUTHENTICATION_ZONE_BY_LOCATION] (context, payload) {
		let location_id = payload.location_id ? payload.location_id : null;
		let zone_id = payload.zone_id ? payload.zone_id : null;
		let ssid = payload.ssid ? payload.ssid : null;
		const data = await AuthenticationService.getAuthenticationZoneByLocation(location_id, zone_id, ssid);
		context.commit(SET_AUTHENTICATION_ZONE, data['data']['data']);
		context.commit(SET_TEMPLATE_PATH, data['data']['data']);
		return data['data']['data'];
	},
	async [GET_TEMPLATE_METHOD_VARIABLES] (context, payload) {
		let zone_id = payload.zone_id ? payload.zone_id : null;
		const data = await AuthenticationTemplateService.getTemplateMethodVariables(zone_id);
		context.commit(SET_TEMPLATE_VARIABLES, data['data']['data']);
		return data['data']['data'];
	},
	[APPLY_TEMPLATE_PATH] (context, payload) {
		const template = payload.template;
		context.commit(SET_TEMPLATE_PATH, payload);
		let templateData = {};
		switch (template) {
			case 'templates/faux_marriott_gpns/':
				templateData.template = 'FauxContainer';
			break;
			case 'templates/innflux_final/':
				templateData.template = 'InnfluxContainer';
				templateData.blockedTemplate = 'BlockedInflux';
				templateData.meetingTemplate = 'MeetingInflux';
				templateData.noMeetingTemplate = 'NoMeetingInflux';
				templateData.sessionTemplate = 'SessionInflux';
				templateData.transportTemplate = 'TransportInflux';
				templateData.welcomeTemplate = 'WelcomeInflux';
			break;
		}
		return templateData;
	}
}

const mutations = {
	[SET_AUTHENTICATION_ZONE] (state, data) {
		state.authenticationZone = data;
	},
	[SET_TEMPLATE_PATH] (state, data) {
		if (data.template) {
			let template = data.template;
		 	switch (template) {
		 		case 'templates/faux_marriott_gpns/':
		 			state.template = 'FauxContainer';
				break;
				case 'templates/innflux_final/':
					state.template = 'InnfluxContainer';
					state.blockedTemplate = 'BlockedInflux';
					state.meetingTemplate = 'MeetingInflux';
					state.noMeetingTemplate = 'NoMeetingInflux';
					state.sessionTemplate = 'SessionInflux';
					state.transportTemplate = 'TransportInflux';
					state.welcomeTemplate = 'WelcomeInflux';
				break;
		 	}
		}
	},
	[SET_TEMPLATE_VARIABLES] (state, data) {
		//state.templateVariables = data;
		for (var index in data) {
			let row = data[index];
			if (row.default_value.length > 0 || row.value) {
				state.templateVariables[row.name] = row.value ? row.value : row.default_value;
			}
		}
	}
}

const getters = {
	authenticationZone (state) {
		return state.authenticationZone;
	},
	templateVariables (state) {
		return state.templateVariables;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}